"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemporaryPageStatus = void 0;
exports.TemporaryPageStatus = {
    UNDER_REVIEW: 'Under Review',
    DELETED: 'Deleted',
};
exports.default = exports.TemporaryPageStatus;
